import axios from 'axios';

type RequestProp = {
  file: File | Blob;
  presignedUrl: string;
};

export const saveFileToBucket = async ({ file, presignedUrl }: RequestProp) => {
  try {
    const res = await axios.put(presignedUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });

    return res.status === 200;
  } catch (error) {
    console.error('Error uploading file to bucket:', error);
    throw error;
  }
};
